import React from 'react';
import { Box, Button, Typography, TextField, useMediaQuery, useTheme } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTranslation } from 'react-i18next';
import { styled } from "@mui/material/styles";

const StyledDatePicker = styled(DatePicker)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    height: "35px",
    borderRadius: "4px",
    backgroundColor: "#F2F2F3",
    border: "1px solid #414958",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "none",
      border:"none"
    },
  },
  "& .MuiInputLabel-outlined": {
    transform: "translate(16px, 8px) scale(1)",
  },
  "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
    transform: "translate(14px, -6px) scale(0.75)",
    backgroundColor: "#F2F2F3",
    padding: "0 4px",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

const DateRangeSelector = ({ startDate, endDate, onStartDateChange, onEndDateChange, onPresetSelect }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDateRangePreset = (preset) => {
    const today = new Date();
    const endDate = new Date(today);
    let startDate;

    switch (preset) {
      case 'today':
        startDate = new Date(today);
        break;
      case 'yesterday':
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 1);
        break;
      case 'last7days':
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 7);
        break;
      case 'last30days':
        startDate = new Date(today);
        startDate.setDate(startDate.getDate() - 30);
        break;
      default:
        startDate = null;
        onStartDateChange(null);
        onEndDateChange(null);
        return;
    }

    onStartDateChange(startDate);
    onEndDateChange(endDate);

    if (onPresetSelect) {
      onPresetSelect(preset, startDate, endDate);
    }
  };

  return (
    <Box >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          gap: 2
        }}>
          <StyledDatePicker
            label={t("From")}
            value={startDate}
            onChange={(newValue) => onStartDateChange(newValue)}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: isMobile ? '100%' : 202,
                  mb: isMobile ? 1 : 0
                }
              }
            }}
          />

          {!isMobile && <Typography variant="body2">{t("to")}</Typography>}

          <StyledDatePicker
            label={t("To")}
            value={startDate}
            onChange={(newValue) => onStartDateChange(newValue)}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: isMobile ? '100%' : 202,
                  mb: isMobile ? 1 : 0
                }
              }
            }}
          />
        </Box>
      </LocalizationProvider>

      {/* Uncomment to restore preset buttons
      <Box sx={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        gap: 1, 
        mt: 1 
      }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleDateRangePreset('today')}
          sx={{ 
            borderRadius: "4px",
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Today
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleDateRangePreset('yesterday')}
          sx={{ 
            borderRadius: "4px",
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Yesterday
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleDateRangePreset('last7days')}
          sx={{ 
            borderRadius: "4px",
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Last 7 Days
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleDateRangePreset('last30days')}
          sx={{ 
            borderRadius: "4px",
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Last 30 Days
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleDateRangePreset('clear')}
          sx={{ 
            borderRadius: "4px",
            width: isMobile ? '100%' : 'auto'
          }}
        >
          Clear
        </Button>
      </Box>
      */}
    </Box>
  );
};

export default DateRangeSelector;